import { Typography, Col, Row } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { ChildPageContentConfig } from "../../../types/cardsType";
import Title from "antd/es/typography/Title";

const { Text } = Typography;
const FlameRetardant = (content: ChildPageContentConfig) => {
  const { text, img } = content;
  if (content.ismobile)
    return (
      <>
        <Title level={4}>Flame retardants Additive Master Batch</Title>
        <Col className={img.className} xs={img.xs} md={img.md}>
          <img
            src={content.img.children}
            width="90%"
            alt="img"
            loading="lazy"
          />
        </Col>
        <Row
          key="content2"
          style={{ paddingBlockStart: "20px" }}
          gutter={content.gutter}
          justify="space-between"
          align="middle"
        >
          <Col className={text.className}>
            <Typography>
              <Paragraph style={{ textAlign: "justify" }}>
                Flame retardants play a crucial role in environments where fire
                hazards are a concern. These additives are specifically designed
                to inhibit or slow down the spread of flames, providing valuable
                protection in situations where fire safety is paramount.
              </Paragraph>
            </Typography>
          </Col>
        </Row>
      </>
    );
  return (
    <>
      <Row
        key="content"
        className={content.className}
        gutter={content.gutter}
        justify="space-between"
        align="middle"
      >
        <Col className={text.className} span={16}>
          <Typography>
            <Paragraph>
              <Text strong>Flame retardants Additive Master Batch: </Text>
              Flame retardants play a crucial role in environments where fire
              hazards are a concern. These additives are specifically designed
              to inhibit or slow down the spread of flames, providing valuable
              protection in situations where fire safety is paramount.
            </Paragraph>
          </Typography>
        </Col>
        <Col className={img.className} span={8}>
          <img
            src={content.img.children}
            width="100%"
            alt="img"
            loading="lazy"
          />
        </Col>
      </Row>
    </>
  );
};

export default FlameRetardant;
